import Immutable from "immutable";

const platformsMap = Immutable.Map({
  pageError: false,
  pageErrorStatus: ""
});

export const error = (state = platformsMap, action) => {
  switch (action.type) {
    case "SET_ERROR_PAGE":
      return state.merge({
        pageError: action.error,
        pageErrorStatus: action.status
      });
    default:
      return state;
  }
};
